import * as strings from "../utils/Strings";

/** GET */
export function apiCallGET(objParams, api, signalAbortController = null) {
	let url = new URL(strings.basePathAPIServer + api);

	Object.keys(objParams).forEach((key) =>
		url.searchParams.append(key, objParams[key])
	);

	console.log(
		"🟢 apiCallGET: " + objParams.function + " ⏩️ url: " + JSON.stringify(url)
	);

	return fetch(url.toString(), { signal: signalAbortController })
		.then((response) => response.json())
		.then((data) => {
			console.log(
				"↩️ apiCallGET: " + objParams.function + " ⏩️ " + JSON.stringify(data)
			);
			return data;
		})
		.catch(function (err) {
			if (err.name === "AbortError") {
				console.log("❌ Fetch Aborted apiCallGET: " + objParams.function);
			} else {
				console.log(
					"⚠️ Fetch Error apiCallGET: " + objParams.function + " ⏩️ " + err
				);
			}
		});
}

// export function apiCallWithBody(
// 	objParams,
// 	api,
// 	body,
// 	signalAbortController = null
// ) {
// 	let url = strings.basePathAPIServer.concat(api, "?");
// 	Object.keys(objParams).forEach((key) => {
// 		url += key + "=" + objParams[key] + "&";
// 	});
// 	url.slice(0, -1);

// 	console.log(
// 		"🟢 apiCallWithBody: " +
// 			objParams.function +
// 			" ⏩️ url: " +
// 			JSON.stringify(url) +
// 			" ⏩️ body: " +
// 			JSON.stringify(body)
// 	);

// 	// return fetch(url.toString(), {
// 	return fetch(url, {
// 		method: "POST",
// 		headers: {
// 			"Content-Type": "text/plain",
// 		},
// 		body: JSON.stringify(body),
// 		signal: signalAbortController,
// 	})
// 		.then((response) => {
// 			return response.json();
// 		})
// 		.then((data) => {
// 			console.log(
// 				"↩️ apiCallWithBody: " +
// 					objParams.function +
// 					" ⏩️ " +
// 					JSON.stringify(data)
// 			);
// 			return data;
// 		})
// 		.catch(function (err) {
// 			if (err.name === "AbortError") {
// 				console.log("❌ Fetch Aborted apiCallWithBody: " + objParams.function);
// 			} else {
// 				console.log(
// 					"⚠️ Fetch Error apiCallWithBody: " +
// 						objParams.function +
// 						" ⏩️ " +
// 						err
// 				);
// 			}
// 		});
// }

// /** POST */
export function apiCallPOST(objParams, api, endpoint = false) {
	// let url = strings.basePathAPIServer + api;

	let url = "";
	if (!endpoint) {
		url = strings.basePathAPIServer.concat(api, "?");

		Object.keys(objParams).forEach((key) => {
			if (key === "function") {
				url += key + "=" + objParams[key] + "&";
			}
		});

		/** Rimuovi carattere & alla fine dell'url */
		url = url.slice(0, -1);

	} else {
		url = endpoint + api;
	}
	
	
	console.log(
		"🟢 apiCallPOST: " +
			objParams.function +
			" ⏩️ url: " +
			JSON.stringify(url) +
			" ⏩️ objParams: " +
			JSON.stringify(objParams)
	);

	return fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(objParams),
		// signal: signalAbortController,
	})
		.then((response) => response.json())
		.then((data) => {
			console.log(
				"↩️ apiCallPOST: " + objParams.function + " ⏩️ " + JSON.stringify(data)
			);
			return data;
		})
		.catch(function (err) {
			if (err.name === "AbortError") {
				console.log("❌ Fetch Aborted apiCallPOST: " + objParams.function);
			} else {
				console.log(
					"⚠️ Fetch Error apiCallPOST: " +
						objParams.function +
						" ⏩️ " +
						err
				);
			}
		});
}

// export function apiCallPOSTWithUrl(
// 	objApi,
// 	urlString,
// 	api,
// 	signalAbortController = null
// ) {
// 	let url = urlString.concat(api, "?");
// 	Object.keys(objApi).forEach((key) => {
// 		if (key === "function") {
// 			url += key + "=" + objApi[key] + "&";
// 		}
// 	});

// 	/** Rimuovi carattere & alla fine dell'url */
// 	url = url.slice(0, -1);

// 	console.log(
// 		"🟢 apiCallPOSTWithUrl: " +
// 			objApi.function +
// 			" ⏩️ url: " +
// 			JSON.stringify(url) +
// 			" ⏩️ objApi: " +
// 			JSON.stringify(objApi)
// 	);

// 	return fetch(url, {
// 		method: "POST",
// 		headers: {
// 			"Content-Type": "application/json",
// 		},
// 		body: JSON.stringify(objApi),
// 		signal: signalAbortController,
// 	})
// 		.then((response) => response.json())
// 		.then((data) => {
// 			console.log(
// 				"↩️ apiCallPOST: " + objApi.function + " ⏩️ " + JSON.stringify(data)
// 			);

// 			return data;
// 		})
// 		.catch(function (err) {
// 			if (err.name === "AbortError") {
// 				console.log("❌ Fetch Aborted apiCallWithBody: " + objApi.function);
// 			} else {
// 				console.log(
// 					"⚠️ Fetch Error apiCallWithBody: " + objApi.function + " ⏩️ " + err
// 				);
// 			}
// 		});
// }

// /** Upload Image */
// export async function uploadImage(objParams, api) {
// 	let url = strings.basePathAPIServer.concat(api, "?");

// 	Object.keys(objParams).forEach((key) => {
// 		if (key === "function") {
// 			url += key + "=" + objParams[key] + "&";
// 		}
// 	});

// 	/** Rimuovi carattere & alla fine dell'url */
// 	url = url.slice(0, -1);
// 	console.log("uploadImage url => " + JSON.stringify(url));

// 	const formData = new FormData();

// 	/** Decommentare se si usa expo-image-picker */
// 	// formData.append("file", {
// 	// 	uri: objParams.file.assets[0].uri,
// 	// 	type: objParams.file.assets[0].mimeType,
// 	// 	name: objParams.file.assets[0].uri.split("/").pop(),
// 	// });

// 	formData.append("file", {
// 		uri: objParams.file.path,
// 		type: objParams.file.mime,
// 		name: objParams.file.path.split("/").pop(),
// 	});

// 	formData.append("folder", objParams.folder);
// 	formData.append("idOrder", objParams.idOrder);
// 	formData.append("idUser", objParams.idUser);
// 	formData.append("typeUser", objParams.typeUser);

// 	console.log("uploadImage formData => " + JSON.stringify(formData));

// 	return fetch(url, {
// 		method: "POST",
// 		body: formData,
// 		headers: {
// 			"Content-Type": "multipart/form-data",
// 		},
// 	})
// 		.then((response) => response.json())
// 		.then((data) => {
// 			console.log(
// 				"<<< RETURN apiCallGET " +
// 					objParams.function +
// 					" => " +
// 					JSON.stringify(data)
// 			);
// 			return data;
// 		})
// 		.catch(function (err) {
// 			console.log("Fetch Error :-S " + objParams.function + " error -> " + err);
// 		});
// }

// /** Upload File */
// export async function uploadFile(objParams, api) {
// 	let url = strings.basePathAPIServer.concat(api, "?");

// 	Object.keys(objParams).forEach((key) => {
// 		if (key === "function") {
// 			url += key + "=" + objParams[key] + "&";
// 		}
// 	});

// 	/** Rimuovi carattere & alla fine dell'url */
// 	url = url.slice(0, -1);
// 	console.log("uploadFile url => " + JSON.stringify(url));

// 	const formData = new FormData();

// 	/** Decommenta se usi react-native-document-picker */
// 	// formData.append("file", {
// 	// 	uri: objParams.file.uri,
// 	// 	type: objParams.file.type,
// 	// 	name: objParams.file.uri.split("/").pop(),
// 	// });

// 	/** expo-document-picker */
// 	formData.append("file", {
// 		uri: objParams.file.uri,
// 		type: objParams.file.mimeType,
// 		filename: objParams.file.uri.split("/").pop(),
// 		name: objParams.file.name,
// 	});

// 	console.log("uploadFile file => " + JSON.stringify(objParams));

// 	formData.append("folder", objParams.folder);
// 	formData.append("idOrder", objParams.idOrder);
// 	formData.append("idUser", objParams.idUser);
// 	formData.append("typeUser", objParams.typeUser);

// 	console.log("uploadFile formData => " + JSON.stringify(formData));

// 	return fetch(url, {
// 		method: "POST",
// 		body: formData,
// 		headers: {
// 			"Content-Type": "multipart/form-data",
// 		},
// 	})
// 		.then((response) => response.json())
// 		.then((data) => {
// 			console.log(
// 				"<<< RETURN apiCallGET " +
// 					objParams.function +
// 					" => " +
// 					JSON.stringify(data)
// 			);
// 			return data;
// 		})
// 		.catch(function (err) {
// 			console.log("Fetch Error :-S " + objParams.function + " error -> " + err);
// 		});

// 	// try {
// 	//   const response = await fetch(url, {
// 	//     method: 'POST',
// 	//     body: formData,
// 	//     headers: {
// 	//       'Content-Type': 'multipart/form-data',
// 	//     },
// 	//   });

// 	//   console.log('return uploadFile ' + objParams.function + ' => ' + JSON.stringify(response));
// 	//   return response;
// 	// } catch (error) {
// 	//   console.error('Upload error:', error);
// 	// }
// }
